import { render, staticRenderFns } from "./PickerChannels.vue?vue&type=template&id=6abcef0e&scoped=true&"
import script from "./PickerChannels.vue?vue&type=script&lang=js&"
export * from "./PickerChannels.vue?vue&type=script&lang=js&"
import style0 from "./PickerChannels.vue?vue&type=style&index=0&id=6abcef0e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abcef0e",
  null
  
)

export default component.exports